// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"wdvohg3MO-E04jk-Zp0Om","icon":"_37lZh9GoR2T048Q28eLwzr","active":"NKoZiqpl5Nfevy2QckTEW"};